var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, bindable } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";
import { LookupHierarchyControl } from "./lookup-hierarchy-control";
var LookupHierarchyList = /** @class */ (function () {
    function LookupHierarchyList(element) {
        this.element = element;
    }
    LookupHierarchyList.prototype.isSelected = function (values, lookup) {
        var result = false;
        if (values && values.length > 0) {
            for (var i = 0; i < values.length; i++) {
                if (lookup && values[i].id == lookup.id) {
                    return true;
                }
                else if (values[i].children) {
                    result = this.isSelected(values[i].children, lookup);
                    if (result) {
                        return true;
                    }
                }
            }
        }
        return result;
    };
    LookupHierarchyList.prototype.selectItem = function (lookup, event) {
        this.vm.selectItem(lookup);
        var changeEvent = new CustomEvent('change', {
            detail: {
                value: lookup
            },
            bubbles: true
        });
        this.element.dispatchEvent(changeEvent);
    };
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], LookupHierarchyList.prototype, "itemSource", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], LookupHierarchyList.prototype, "change", void 0);
    __decorate([
        bindable,
        __metadata("design:type", LookupHierarchyControl)
    ], LookupHierarchyList.prototype, "vm", void 0);
    LookupHierarchyList = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Element])
    ], LookupHierarchyList);
    return LookupHierarchyList;
}());
export { LookupHierarchyList };
